import { ChevronRight as ChevronRightIcon } from 'lucide-react';
import {
  Collapsible,
  CollapsibleContent,
  CollapsibleTrigger,
} from '@reflex/ui/components/ui/collapsible';
import { PanelTitle } from '@reflex/ui/components/layout/Typography';

export function WebContributionRow({
  icon: Icon,
  label,
  testId,
  children,
}: {
  icon: React.ComponentType<{ className?: string }>;
  label: string;
  testId?: string;
  children: React.ReactNode;
}) {
  return (
    <Collapsible>
      <CollapsibleTrigger
        data-testid={testId}
        className="group flex w-full items-center gap-2 rounded-lg border px-4 py-3 text-left transition-colors hover:bg-muted/50"
      >
        <Icon className="h-4 w-4 shrink-0 text-muted-foreground" />
        <PanelTitle as="span" size="sm" className="min-w-0 flex-1 text-left">
          {label}
        </PanelTitle>
        <ChevronRightIcon className="h-3.5 w-3.5 text-muted-foreground transition-transform group-data-[state=open]:rotate-90" />
      </CollapsibleTrigger>
      <CollapsibleContent>
        <div className="mt-1 space-y-1 pl-6">{children}</div>
      </CollapsibleContent>
    </Collapsible>
  );
}
